export default __webpack_public_path__ + "static/media/1JulyDark.831a617f.svg";